import Atomchat, { AtomchatButton } from './components/Atomchat';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelAtomchatCategory } = opts;
  AtomchatButton(bm, labelAtomchatCategory, labels.atomchatButton, types.atomchatButton);
  Atomchat(dc, labels.atomchatButton, types.atomchatButton, opts);
};
